/**
 * Transport Auction
 */
export default class TransportAuction {
    constructor() {
        if (document.getElementsByClassName('dv__trp-auction').length < 1) {
            return;
        }
        
        this.changeLogoUrl();
    }

    /**
     * @description If transport page change URL for site logo
     */
    changeLogoUrl() {
        const url = document.querySelector('#transportAuctionRedirectUrl').value;
        const urlElement = document.querySelector('#lm2LogoUrl');

        if (url !== '') {
            urlElement.setAttribute('href', url);
        }  
    }
}
